import { connect, useSelector } from 'react-redux'
import React, { useState } from 'react'
import { jt, t } from 'ttag'

import {
  loadDecoderResults,
  loadSubsequentDecoderResults
} from '../../../actions/assessments/skillsProfiler'
import SearchQueryHandlerComponent from '../../../components/search/SearchQueryHandlerComponent'
import { useTitleChange } from '../../../util/hooks'

const SkillsDecoderResults = props => {
  const pageTitle = t`Skills Decoder :: Results`

  useTitleChange(pageTitle)

  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadDecoderResults
  const loadMoreFunction = loadSubsequentDecoderResults(filterModel)
  const searchRequest = useSelector(state => state.assessments.skillsDecoder.results)

  return (
    <>
      <div className="container">
        <p>
          {jt`Your skills profile returned the following occupations.
           You can compare up to four occupations by selecting the boxes to the left of the desired occupations and then clicking 
           on the Compare Selected button at the bottom of the page. You can also filter occupation lists by Job Zone (preparation required),
            salary, and more to help you refine your search.`}
        </p>
      </div>
      <SearchQueryHandlerComponent
        loadFunction={loadFunction}
        loadMoreFunction={loadMoreFunction}
        setFilterModel={setFilterModel}
        searchRequest={searchRequest}
        {...props}
      />
    </>
  )
}

export { SkillsDecoderResults }
